var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-group field-file-input"},[_c('base64-upload',{key:_vm.refresh,attrs:{"imageSrc":_vm.value},on:{"change":_vm.onChangeImage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }